module.exports = __webpack_public_path__ + "static/media/linkIconBlue.30317e0c.svg";